/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SourceOption } from './SourceOption';
import {
    SourceOptionFromJSON,
    SourceOptionFromJSONTyped,
    SourceOptionToJSON,
    SourceOptionToJSONTyped,
} from './SourceOption';

/**
 * 
 * @export
 * @interface FindAllSourceOptions200Response
 */
export interface FindAllSourceOptions200Response {
    /**
     * 
     */
    data: Array<SourceOption>;
}

/**
 * Check if a given object implements the FindAllSourceOptions200Response interface.
 */
export function instanceOfFindAllSourceOptions200Response(value: object): value is FindAllSourceOptions200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function FindAllSourceOptions200ResponseFromJSON(json: any): FindAllSourceOptions200Response {
    return FindAllSourceOptions200ResponseFromJSONTyped(json, false);
}

export function FindAllSourceOptions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSourceOptions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(SourceOptionFromJSON)),
    };
}

export function FindAllSourceOptions200ResponseToJSON(json: any): FindAllSourceOptions200Response {
    return FindAllSourceOptions200ResponseToJSONTyped(json, false);
}

export function FindAllSourceOptions200ResponseToJSONTyped(value?: FindAllSourceOptions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(SourceOptionToJSON)),
    };
}

